import React, {PropTypes} from 'react';


class RhinoRadio extends React.Component {

  static defaultProps = {
    disabled: false,
    label: '',
    name: '',
    selected: false,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className='RhinoRadio'>
        <label className={'control control--radio'}>{this.props.label || ''}
          <input 
            type='radio' 
            name={this.props.name || ''} 
            disabled={this.props.disabled || false} 
            checked={this.props.selected || false}
            onChange={this.props.onChange.bind(this)} />
          <div className='control__indicator'></div>
        </label>
      </div>
    );
  }
}
export default RhinoRadio;